import { createAsyncThunk } from '@reduxjs/toolkit';
import request from '../../../app/api/requests';
import { Subscription, SubscriptionRootState } from './types';
import { isSubscriptionForUser } from './is-subscription-for-user';

const loadError = 'Не удалось загрузить подписку. Повторите попытку.';

export const fetchSubscription = createAsyncThunk<
    Subscription,
    { force?: boolean } | void,
    { state: SubscriptionRootState; rejectValue: string; pendingMeta: { userId: string } }
>(
    'subscription/fetch',
    async (_, { getState, signal, rejectWithValue }) => {
        const userId = getState().userAuthSettings.userId;
        try {
            // The authenticated user is resolved by Backend from the access token.
            const { data } = await request.get<Subscription>('/Subscriptions', { signal, timeout: 15000 });
            if (!isSubscriptionForUser(data, userId)) {
                return rejectWithValue('Получены некорректные данные подписки. Повторите попытку.');
            }
            return data;
        } catch {
            return rejectWithValue(loadError);
        }
    },
    {
        condition: (options, { getState }) => {
            const { userAuthSettings: user, subscription } = getState();
            return user.isAuth && !!user.userId
                && (options?.force || !(subscription.currentRequestId && subscription.requestUserId === user.userId));
        },
        getPendingMeta: (_, { getState }) => ({ userId: getState().userAuthSettings.userId }),
    },
);
